import { UserSignUpSources, UserStatuses } from 'globals/constants'
import { useMembershipHelper } from 'hooks/membership/membership-helper.hook'
import { useRolesHelper } from 'hooks/roles/roles.helper'
import { useSelector } from 'react-redux'
import { AuthorizeProps } from 'sdk'
import { AuthSliceSelector } from 'store/slices'

export const useAuthorizeHelper = () => {
  const { IsPaidMember, IsOldPaidMember } = useMembershipHelper()
  const { IsAdmin, IsSubAccount, IsTrialUser, IsSuperAdmin } = useRolesHelper()
  const { CurrentUser } = useSelector(AuthSliceSelector)

  const isAuthorized = (arg: AuthorizeProps) => {
    if (
      (arg.customCondition == null || arg.customCondition) &&
      (!arg.allowedToAdmin || IsAdmin()) &&
      (!arg.allowedToSuperAmin || IsSuperAdmin()) &&
      (!arg.hiddenFromSuperAdmin || !IsSuperAdmin()) &&
      (!arg.hiddenFromSubAccounts || !IsSubAccount()) &&
      (!arg.allowedToPaidUsers || IsPaidMember() || IsTrialUser()) &&
      (!arg.hiddenFromTrialUsers || !IsTrialUser()) &&
      (!arg.hiddenFromAdmin || !IsAdmin()) &&
      (!arg.allowedToCompleteUsers || CurrentUser?.Status === UserStatuses.COMPLETED || CurrentUser?.Status == null) &&
      (!arg.hiddenFromOldPaidMembers || !IsOldPaidMember()) &&
      (!arg.allowedToAppSignUps || CurrentUser?.Source === UserSignUpSources.App) &&
      (!arg.allowedToPaidUsersAndAdmin || IsPaidMember() || IsAdmin()) &&
      (!arg.allowedToPaidUsersAndTrialUsersAndAdmin || IsPaidMember() || IsAdmin() || IsTrialUser())
    ) {
      return true
    }
    return false
  }
  return { isAuthorized }
}
